import deepCopy from "../utils/deepCopy"

const INVOICE_TYPE_ADDRESS = 'address'
const INVOICE_TYPE_POST = 'post'

const ADDRESS_TREE_FIELDS = [
  'district_id',
  'city_id',
  'locality_id',
  'area_id',
  'street_id',
  'house_id'
]

export const locationChangerMixin = {
  data () {
    return {
      states: {},
      fields: {
        // location type
        _locationType: INVOICE_TYPE_ADDRESS,
        // post off
        pochtamt_index: '',
        pochtamtName: '',
        // select location
        district_id: '',
        city_id: '',
        locality_id: '',
        area_id: '',
        street_id: '',
        house_id: ''
      }
    }
  },
  watch: {
    'fields._locationType': 'onLocationTypeChanged'
  },
  computed: {
    postOffices () {
      return this.$store.getters.readUrlEndpoint(
        this.getPostOfficesEndpoint()
      ).data.map(({name, post_code, address}) => ({
        id: post_code,
        name: `${post_code} ${name} (${address})`
      }))
    },
    INVOICE_TYPE_ADDRESS () {
      return INVOICE_TYPE_ADDRESS
    },
    INVOICE_TYPE_POST () {
      return INVOICE_TYPE_POST
    },
    locationTypes () {
      return [
        {id: INVOICE_TYPE_ADDRESS, name: 'Адрес'},
        {id: INVOICE_TYPE_POST, name: 'Почтовое отделение'}
      ]
    }
  },
  methods: {
    getPostOfficesEndpoint() {
      return null
    },
    // сохранение данные после изменения типа
    // и их восстановление, есть есть
    onLocationTypeChanged (newValue, prevValue) {
      this.states[prevValue] = Object.assign({}, this.fields)
      const fields = [
        ...ADDRESS_TREE_FIELDS,
        'pochtamt_index', 'pochtamtName',
        '_lastSelectedValue', 'address'
      ]
      if (this.states[newValue]) {
        fields.forEach(fName => {
          this.fields[fName] = this.states[newValue][fName]
        })
      } else {
        fields.forEach(fName => {
          this.fields[fName] = ''
        })
      }
    },
    prepareLocationFieldsForSend (fields) {
      const sendData = deepCopy(fields)
      if (sendData._locationType === INVOICE_TYPE_ADDRESS) {
        sendData.pochtamt_index = null
        ADDRESS_TREE_FIELDS.forEach(field => {
          if (!sendData[field]) {
            sendData[field] = null
          }
        })
      }

      if (sendData._locationType === INVOICE_TYPE_POST) {
        // this.fields._post_office_id = ''
        ADDRESS_TREE_FIELDS.forEach(field => {
          sendData[field] = null
        })
      }
      return sendData
    }
  }
}
